// src/SiteSelect.js
import { useEffect, useMemo, useState } from "react";
import { apiFetch } from "./api";

export default function SiteSelect({ division, onSelect, onBack }) {
  const [sites, setSites] = useState([]);
  const [loading, setLoading] = useState(true);
  const [err, setErr] = useState("");
  const [q, setQ] = useState("");

  useEffect(() => {
    if (!division) return;

    let alive = true;

    async function load() {
      setLoading(true);
      setErr("");
      try {
        const qs = new URLSearchParams({ division });
        const res = await apiFetch(`/api/sites?${qs}`);
        if (!res.ok) throw new Error(`HTTP ${res.status}`);
        const data = await res.json();
        if (alive) setSites(data || []);
      } catch {
        if (alive) setErr("Failed to load sites");
      } finally {
        if (alive) setLoading(false);
      }
    }

    load();
    return () => { alive = false; };
  }, [division]);

  const filtered = useMemo(() => {
    const needle = (q || "").trim().toLowerCase();
    if (!needle) return sites;
    return (sites || []).filter((s) => String(s).toLowerCase().includes(needle));
  }, [sites, q]);

  const card = { maxWidth: 560, margin: "40px auto", padding: 18 };
  const panel = {
    background: "white",
    border: "1px solid #e5e7eb",
    borderRadius: 14,
    boxShadow: "0 6px 18px rgba(0,0,0,0.06)",
    padding: 18,
  };
  const btn = {
    width: "100%",
    padding: "12px 14px",
    borderRadius: 12,
    border: "1px solid #e5e7eb",
    background: "#f9fafb",
    cursor: "pointer",
    textAlign: "left",
    fontWeight: 600,
  };
  const subtle = { color: "#6b7280", fontSize: 13 };

  return (
    <div style={card}>
      <div style={panel}>
        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", gap: 12 }}>
          <div>
            <div style={{ fontSize: 20, fontWeight: 800 }}>Select Site</div>
            <div style={subtle}>
              Division: <b>{division}</b>
            </div>
          </div>

          <button
            onClick={onBack}
            style={{
              padding: "10px 12px",
              borderRadius: 12,
              border: "1px solid #e5e7eb",
              background: "white",
              cursor: "pointer",
              fontWeight: 600,
            }}
          >
            Change Division
          </button>
        </div>

        <div style={{ marginTop: 14 }}>
          <input
            value={q}
            onChange={(e) => setQ(e.target.value)}
            placeholder="Search sites…"
            style={{
              width: "100%",
              padding: "10px 12px",
              borderRadius: 12,
              border: "1px solid #e5e7eb",
              outline: "none",
            }}
          />
        </div>

        <div style={{ marginTop: 12 }}>
          {loading && <div style={subtle}>Loading sites…</div>}
          {err && <div style={{ marginTop: 8, color: "#b91c1c", fontWeight: 600 }}>{err}</div>}

          {!loading && !err && filtered.length === 0 && (
            <div style={{ marginTop: 10, color: "#b91c1c", fontWeight: 600 }}>
              No sites found for this division.
            </div>
          )}
        </div>

        <div style={{ display: "grid", gap: 10, marginTop: 14 }}>
          {filtered.map((s) => (
            <button
              key={s}
              onClick={() => onSelect(s)}
              style={btn}
              type="button"
              onMouseEnter={(e) => (e.currentTarget.style.background = "#ecfeff")}
              onMouseLeave={(e) => (e.currentTarget.style.background = "#f9fafb")}
            >
              <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
                <span style={{ fontSize: 18 }}>🏭</span>
                <div style={{ flex: 1 }}>
                  <div>{s}</div>
                  <div style={{ fontSize: 12, color: "#6b7280", fontWeight: 500 }}>
                    Tap to continue
                  </div>
                </div>
                <span style={{ color: "#9ca3af" }}>→</span>
              </div>
            </button>
          ))}
        </div>
      </div>
    </div>
  );
}
